/**
 * AP-37 Nachtrag 6 (N6-2) — die Positionsübersicht **merkt sich, was zugeklappt war**: die Gruppen und die
 * Positionen, deren Texte anders stehen als der Schalter „Texte einblenden“.
 *
 * Der Reiter wird beim Wechsel zu einer Position abgebaut; sein Zustand ging dabei verloren, und beim
 * Zurückkommen stand wieder alles aufgeklappt da. Gemerkt wird je Kalkulation im `localStorage` des Browsers —
 * wie der Schalter „Texte einblenden“ selbst (N1-22). Es ist eine Ansicht, keine Einstellung der Kalkulation.
 *
 * Behalten werden nur die zuletzt benutzten Kalkulationen: Der Speicher ist klein, und eine Kalkulation, die
 * lange niemand geöffnet hat, darf wieder aufgeklappt beginnen.
 */
const SCHLUESSEL = 'symphenia.kalkulation.klappen'
const HOECHSTENS = 40

export interface KlappZustand {
  /** Zugeklappte Gruppen. */
  zu: string[]
  /** Positionen, deren Texte anders stehen als der Schalter „Texte einblenden“. */
  texte: string[]
}

type Ablage = Record<string, KlappZustand & { t: number }>

function lies(): Ablage {
  try {
    const a: unknown = JSON.parse(localStorage.getItem(SCHLUESSEL) ?? '{}')
    return a && typeof a === 'object' && !Array.isArray(a) ? (a as Ablage) : {}
  } catch {
    return {}
  }
}

const kennungen = (x: unknown): string[] => (Array.isArray(x) ? x.filter((y): y is string => typeof y === 'string') : [])

export function liesKlappZustand(kalkulationId: string): KlappZustand {
  const e = lies()[kalkulationId]
  return { zu: kennungen(e?.zu), texte: kennungen(e?.texte) }
}

/** Merkt den Zustand einer Kalkulation; ist nichts zugeklappt, verschwindet ihr Eintrag. */
export function merkeKlappZustand(kalkulationId: string, zustand: KlappZustand, jetzt = Date.now()): void {
  try {
    const a = lies()
    if (zustand.zu.length === 0 && zustand.texte.length === 0) delete a[kalkulationId]
    else a[kalkulationId] = { zu: zustand.zu, texte: zustand.texte, t: jetzt }
    const behalten = Object.entries(a)
      .sort((x, y) => (y[1]?.t ?? 0) - (x[1]?.t ?? 0))
      .slice(0, HOECHSTENS)
    localStorage.setItem(SCHLUESSEL, JSON.stringify(Object.fromEntries(behalten)))
  } catch {
    // ohne Speicher gilt der Zustand nur, solange der Reiter steht
  }
}
